import type { Step } from '@essent/contract';
import { StepName, StepStatus } from '@essent/contract';

const isStepCompleted = (stepName: StepName) => (steps: Step[]) =>
  steps.find(({ step }) => step === stepName)?.status === StepStatus.COMPLETED;

export const isDeliveryStarted = isStepCompleted(StepName.DELIVERYSTART);
